<template>
    <div class="comment-body">
        <div class="item" v-for="(item, index) in dataSource" :key="index">
            <div class="avatar">
                <img :src="item.user.image" alt="">
                <img src="@/assets/img/man.png" alt="" class="sex" v-if="item.user.gender == 'm'">
                <img src="@/assets/img/icon_women.png" alt="" class="sex" v-else>
            </div>
            <div class="right">
                <div class="top">
                    <span>{{ item.user.nickname }}</span>
                    <div class="thumb" @click="openDownModal">
                        <span class="iconfont icon-thumb"></span>
                        {{ item.loves }}
                    </div>
                </div>
                <div class="content">{{ item.content }}</div>
                <div class="reply" v-if="item.comment.length > 0">
                    <div class="r-item" v-for="(reply, index2) in item.comment" :key="reply.id">
                        <span class="r-name">{{reply.user.nickname}}:</span>
                        {{ reply.content }}
                    </div>
                </div>
                <div class="bottom">
                    <span class="time">{{item.create_time}}</span>
                     <span class="to-top" @click="openDownModal">置顶</span>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "CommentList",
    props:{
        dataSource: {
            type: Array,
            default:()=>[]
        }
    },
    created() {
        console.log(this.dataSource);
    }
}
</script>

<style scoped lang="less">
.comment-body{
    padding: 20px 20px 0 20px;
    box-sizing: border-box;
    .item:extend(.flex-btw){
        align-items: flex-start;
        padding-bottom: 20px;
        margin-bottom: 20px;
        border-bottom: 1px solid #EEEEEE;
        &:last-child{
            margin-bottom: 0;
        }
        .avatar{
            min-width: 40px;
            max-width: 40px;
            min-height: 40px;
            max-height: 40px;
            border-radius: 50%;
            margin-right: 12px;
            position: relative;
            .sex{
                position: absolute;
                right: 0;
                bottom: 0;
                width: 16px;
                height: 16px;
            }
            img{
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }
        .right{
            flex: 1;
            .top:extend(.flex-btw){
                font-size: 14px;
                margin-bottom: 8px;
                .thumb:extend(.flex-cen){
                    font-size: 12px;
                }
            }
            .content{
                font-size: 16px;
            }
            .reply{
                margin-top: 12px;
                box-sizing: border-box;
                padding: 10px 12px;
                background-color: #F8F8F8;
                border-radius: 6px;
                font-size: 14px;
                .r-name{
                    color: #2E8CFF;
                    white-space: nowrap;
                }
                p{
                    word-break: break-all;
                }
            }
            .bottom:extend(.flex-btw){
                margin-top: 8px;
                font-size: 12px;
                color: #646464;
                .to-top{
                    color: #2E8CFF;
                }
            }
        }
    }

}
</style>
